module.exports = __webpack_public_path__ + "static/media/main-bird-1.09f12ab4.png";